import { createApp } from 'vue'
import Iletisim from './Iletisim.vue'
import './assets/global.css'

createApp(Iletisim).mount('#iletisim')
